import { Button, TextField } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import SelectInput from "../../../components/Select/SelectInput";
import { Context } from "../../../context/context";
import {
  editCompanieValues,
  getCompanyById,
  getCompanies,
} from "../../../services/company-service";
import {
  editProduct,
  getProductByCompanyId,
} from "../../../services/product-service";

import "./PricesAndCosts.scss";

export default function PricesAndCosts() {
  const { sidebar } = useContext(Context);
  const accessToken = localStorage.getItem("token");
  const [selectedCompanie, setSelectedCompanie] = useState("");
  const [showData, setShowData] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [products, setProducts] = useState([]);
  const [formValues, setFormValues] = useState({
    km_cost: "",
    departure_cost: "",
    products,
  });

  async function getCompaniesData() {
    const result = await getCompanies(accessToken);
    setCompanies(result);
  }

  async function getCompanieValues() {
    if (selectedCompanie) {
      const result = await getCompanyById(accessToken, selectedCompanie);
      const products = await getProductByCompanyId(
        accessToken,
        selectedCompanie
      );

      setProducts(products);
      setCompanyData(result);
      setFormValues((prevState) => {
        return {
          ...prevState,
          km_cost: result.custo_km,
          departure_cost: result.custo_partida,
          products,
        };
      });
      setShowData(true);
    }
  }

  async function handleChanges(e) {
    setFormValues((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const payload = {
      id: companyData.id,
      custo_km: formValues.km_cost,
      custo_partida: formValues.departure_cost,
    };

    await Promise.all(
      formValues.products.map((product) => {
        editProduct(accessToken, product);
      })
    );

    const update = await editCompanieValues(accessToken, payload);
    console.log(update);
    // editProduct(accessToken, data);
  }

  useEffect(() => {
    getCompaniesData();
  }, []);

  useEffect(() => {
    getCompanieValues();
  }, [selectedCompanie]);

  return (
    <>
      <main className={sidebar ? "container" : "container-full"}>
        <h1>Editar Preços e Custos</h1>

        <div className="form-container margin-container">
          <SelectInput
            value={selectedCompanie}
            name="Selecione uma empresa"
            setValue={setSelectedCompanie}
            selectValues={companies}
          />

          {showData && (
            <>
              <TextField
                label="Custo KM"
                name="km_cost"
                value={formValues.km_cost}
                onChange={handleChanges}
                autoComplete="off"
              />

              <TextField
                label="Custo de Partida"
                name="departure_cost"
                value={formValues.departure_cost}
                onChange={handleChanges}
                autoComplete="off"
              />

              {products.map((product) => {
                return (
                  <TextField
                    key={product.id}
                    type="number"
                    label={product.name}
                    name={product.name}
                    value={
                      formValues.products.find((item) => item.id === product.id)
                        .price
                    }
                    inputProps={{
                      step: "0.1",
                    }}
                    onChange={(e) => {
                      setFormValues((prevState) => {
                        let newArray = prevState.products;
                        const teste = newArray.findIndex(
                          (item) => item.id === product.id
                        );

                        newArray[teste].price = Number(e.target.value);

                        return {
                          ...prevState,
                          products: newArray,
                        };
                      });
                    }}
                    autoComplete="off"
                  />
                );
              })}

              <Button type="submit" onClick={handleSubmit} variant="contained">
                Atualizar
              </Button>
            </>
          )}
        </div>
      </main>
    </>
  );
}
